import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { cropStyle } from "../lib/cropStyle";
import { useItinerary } from "../context/ItineraryContext";

export const AttractionsGrid = ({ attractions = [] }) => {
  const navigate = useNavigate();
  const { add } = useItinerary();
  return (
    <div className="grid md:grid-cols-3 gap-6">
      {attractions.map((a, i) => {
        const clickable = !!a.gallery_category;
        const glink = `/gallery?cat=${encodeURIComponent(a.gallery_category)}${a.gallery_subcategory ? `&sub=${encodeURIComponent(a.gallery_subcategory)}` : ""}`;
        return (
          <div key={a.title || i} className="group relative rounded-2xl overflow-hidden h-72 bg-forest/60" data-testid={`attraction-card-${i}`}>
            {a.image && (
              <img
                src={a.image} alt={a.title}
                onClick={clickable ? () => navigate(glink) : undefined}
                className={`h-full w-full object-cover object-center group-hover:scale-105 transition-transform duration-500 ${clickable ? "cursor-pointer" : ""}`}
                style={cropStyle(a.image_position, a.image_zoom)}
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 to-transparent pointer-events-none" />
            <div className="absolute bottom-0 p-6 text-cream">
              <h3 className="font-serif text-2xl">{a.title}</h3>
              <p className="text-sm text-cream/75 mt-1">{a.desc}</p>
              <div className="flex flex-wrap gap-2 mt-4">
                {clickable && (
                  <button onClick={() => navigate(glink)} data-testid={`attraction-view-gallery-${i}`} className="text-xs font-semibold rounded-full bg-cream/15 hover:bg-cream/25 text-cream px-4 py-2 transition-colors">View gallery →</button>
                )}
                {a.experience_id && (
                  <button onClick={() => { add(a.experience_id); toast.success(`${a.title} added to your itinerary`); }} data-testid={`attraction-add-stay-${i}`} className="text-xs font-semibold rounded-full bg-rose hover:bg-rose/90 text-white px-4 py-2 transition-colors">Add to stay +</button>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
